<template>
    <semester-required>
        <template #semester-in-progress="{ semester }">
            <RegisterHeader
                :semester="semester"
            />
            <RegisterForms
                :semester="semester"
                v-model="reason"
            />
            <b-overlay
                :show="!!reason"
            >
                <template #overlay>
                    <font-awesome-icon
                        icon="lock"
                        class="mr-2"
                    ></font-awesome-icon>
                    {{ reason }}
                </template>

                <RegisterStudents
                    :semester="semester"
                />
            </b-overlay>
        </template>
    </semester-required>
</template>
<script>
import RegisterHeader from './components/RegisterHeader.vue';
import RegisterForms from './components/RegisterForms.vue';
import RegisterStudents from './components/RegisterStudents.vue';
import SemesterRequired from '@/components/authz/SemesterRequired.vue';

export default {
    components: { SemesterRequired, RegisterHeader, RegisterForms, RegisterStudents },
    data() {
        return { reason: '' };
    }
}
</script>
<style scoped>
    .text-strike, .textStrike {
        text-decoration: line-through;
    }
</style>